import { render } from "./ExtratoPontos.vue?vue&type=template&id=06cdd158"
import script from "./ExtratoPontos.vue?vue&type=script&lang=js"
export * from "./ExtratoPontos.vue?vue&type=script&lang=js"
script.render = render

export default script